import { Box, IconButton } from '@mui/material';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faClose, faTrash } from '@fortawesome/pro-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import CardContent from '@mui/material/CardContent';
import Card from '@mui/material/Card';
import UnmappedRecordStatus from '../../enums/UnmappedRecordStatus';

const StyledCard = styled(Card)`
  && {
    border-radius: 8px;
  }
`;

const StyledBox = styled(Box)`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    min-height: 150px;
    position: relative;
`;

const CloseButton = styled(IconButton)`
    && {
        position: absolute;
        top: 0;
        right: 0;
        background: transparent;
        border: none;
        cursor: pointer;
        padding: 4px;
        font-size: 16px;
        color: ${(props) => props.theme.palette.grey[700]};
    }
`;

const StyledIcon = styled(FontAwesomeIcon)`
    background-color: #E7F3EB;
    color: #138639;
    font-size: 24px;
    border-radius: 50%;
    padding: 14px;
`;

const Message = styled.div(({ theme }) => `
    font-family: ${theme.typography.fontFamily};
    font-size: 16px;
    font-weight: 500;
    color: ${theme.palette.grey[900]};
    text-align: center;
`);

const statusMap = {
  [UnmappedRecordStatus.ADDED]: { icon: faCheck, message: 'Traits.Status.Added' },
  [UnmappedRecordStatus.MAPPED]: { icon: faCheck, message: 'Traits.Status.Updated' },
  [UnmappedRecordStatus.DELETED]: { icon: faTrash, message: 'Traits.Status.Deleted' },
  [UnmappedRecordStatus.RESOLVED_HIDDEN]: null,
  [UnmappedRecordStatus.UNMAPPED]: null,
};

function ResolvedTraitCard({ type, onClose }: Readonly<{ type: UnmappedRecordStatus, onClose: () => void }>) {
  const { t } = useTranslation();
  const statusConfig = statusMap[type];

  return (
    statusConfig ? (
      <StyledCard variant="outlined" sx={{ marginBottom: 2 }} data-testid="resolved-trait-card">
        <CardContent>
          <StyledBox>
            <CloseButton aria-label="close" onClick={onClose}>
              <FontAwesomeIcon icon={faClose} />
            </CloseButton>
            <StyledIcon icon={statusConfig.icon} />
            <Message>
              {t(statusConfig.message)}
            </Message>
          </StyledBox>
        </CardContent>
      </StyledCard>
    ) : null
  );
}

export default ResolvedTraitCard;
